/* v8 ignore start */
import React from "react";
import IdMindLogo from "assets/idmind-logo.png";

export const MockIdMind = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#32373c",
        minHeight: "1500px",
        height: "100vh",
        width: "100%",
        paddingTop: "10vh",
      }}
    >
      <img
        src={IdMindLogo}
        style={{
          height: "calc(269px / 4)",
        }}
        alt="Identity Mind logo"
      />
    </div>
  );
};

